<template>
  <div
    class="font-weight-bold relative widget-title"
    :class="{
      'grey--text text--darken-4': !light,
      'white--text': light,
      'text-h5 text-md-h4 text-lg-h3 text-center pb-5': !small,
      'text-h6 text-md-h5 pb-3': small,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.widget-title {
  &:before {
    border-left: 50px solid var(--v-primary-lighten3);
    border-right: 8px solid var(--v-primary-lighten3);
    bottom: 0;
    content: "";
    height: 2px;
    left: 0;
    padding-left: 6px;
    position: absolute;
  }
  &.text-center {
    &:before {
      left: 50%;
      margin-left: -32px;
    }
  }
}
</style>
